<template>
    <div>
        <!-- detail_Basic Info -->
        <table class="create_table">
            <colgroup>
                <col width="270">
                <col width="*">
                <col width="*">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{$t('FIELD.COUNTRY.NAME')}}</th>
                    <td colspan="2">
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100" v-model="rhqCd">
                                    <option :value="rhqCd" selected>{{rhqNm}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100" v-model="corpNo">
                                    <option :value="corpNo" selected>{{corpNm}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100" v-model="countryCd">
                                    <option :value="countryCd" selected>{{countryNm}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.EUR.APPR.MODE')}}</th>
                    <td colspan="2">
                        <fieldset class="ui_table">
                            <span class="radio_item">
                                <label v-for="code in aprAutoTypes" :key="code.code" class="radiobox-wrap">
                                    <input type="radio" name="apprAutoType" :value="code.code" v-model="aprAutoTpCd" :disabled="corpCd != 'C100'"><i class="radio-icon"></i>
                                    <em>{{code.codeName}}</em>
                                </label>
                            </span>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.EUR.REPAIR.INFO.EFCT.PERIOD')}}</th>
                    <td>{{$t('FIELD.EUR.EFCTV.PERIOD')}}
                        <span class="mg20">
                            <input type="text" class="text_input text_center w50px" v-model.number="readEfctDay" maxlength="2" @keyup="onlyNumber" />
                        </span>{{$t('FIELD.GLOBAL.DAYS')}}
                    </td>
                    <td>{{$t('FIELD.EUR.MAX.PERIOD')}}
                        <span class="mg20">
                            <input type="text" class="text_input text_center w50px" v-model.number="readEfctMax" :disabled="adminAuthYn == 'N'" maxlength="2" @keyup="onlyNumber" />
                        </span>{{$t('FIELD.GLOBAL.DAYS')}}
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.EUR.USER.REG.EFCT.PERIOD')}}</th>
                    <td>{{$t('FIELD.EUR.EFCTV.PERIOD')}}
                        <span class="mg20">
                            <input type="text" class="text_input text_center w50px" v-model.number="userExpireMon" maxlength="2" :disabled="expireUseYn == 'N'" @keyup="onlyNumber" />
                        </span>{{$t('FIELD.EUR.STD.MONTH')}}
                    </td>
                    <td>{{$t('FIELD.EUR.MAX.PERIOD')}}
                        <span class="mg20">
                            <input type="text" class="text_input text_center w50px" v-model.number="userExpireMax" :disabled="expireUseYn == 'N' || adminAuthYn == 'N'" maxlength="2" @keyup="onlyNumber" />
                        </span>{{$t('FIELD.EUR.STD.MONTH')}}
                        <span class="mg20"></span>
                        <span class="mg20">
                            USE Y/N &nbsp;
                            <select class="slt_white w10p" v-model="expireUseYn" :disabled="adminAuthYn == 'N'">
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                            </select>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.EUR.APPR.RULE')}}</th>
                    <td colspan="2">
                        <fieldset class="ui_table">
                            <span class="radio_item">
                                <label v-for="code in aprRuleTypes" :key="code.code"  class="radiobox-wrap">
                                    <input type="radio" name="apprRuleType" :value="code.code" v-model="aprRuleTpCd"><i class="radio-icon"></i>
                                    <em>{{code.codeName}}</em>
                                </label>
                            </span>
                        </fieldset>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="grid_wrap mt-20">
            <!-- Count -->
            <div class="grid_title">{{$t('FIELD.EUR.PERSON.CHRG.VOC')}}</div>
            <div class="btn_wrap">
                <a href="JavaScript:" class="btn_white" title="" @click="userDel">{{$t('FIELD.GLOBAL.DELETE')}}</a>
                <a href="JavaScript:" class="btn_white" title="" @click="userAdd">{{$t('FIELD.ADMIN.ADD')}}</a>
            </div>
            
            <!-- Grid -->
            <table class="data_table_ty2">
                <colgroup>
                    <col width="5%">
                    <col width="30%">
                    <col width="30%">
                    <col width="*">
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <label class="checkbox-wrap">
                                <input type="checkbox" v-model="selectAll" @change="checkAll()" />
                                <i class="check-icon"></i>
                            </label>
                        </th>
                        <th>{{$t('FIELD.APPROVAL.PERSON.CHARGE')}} {{$t('FIELD.GLOBAL.LOGIN.ID')}}</th>
                        <th>{{$t('FIELD.APPROVAL.PERSON.CHARGE')}} {{$t('FIELD.USER.NAME')}}</th>
                        <th>{{$t('FIELD.APPROVAL.PERSON.CHARGE')}} {{$t('FIELD.GLOBAL.EMAIL')}}</th>
                    </tr>
                </thead>
                <tbody class="text_center">
                    <tr v-for="user in vocUsers" :key="user.LOGIN_NO">
                        <td class="tC">
                            <label class="checkbox-wrap">
                                <input type="checkbox" v-model="user.selected" @change="selectRowChk(user)" />
                                <i class="check-icon"></i>
                            </label>
                        </td>
                        <td>{{user.LOGIN_ID}}</td>
                        <td>{{user.LOGIN_NM}}</td>
                        <td>{{user.EMAIL}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="btn_wrap_full topLine">
            <a href="JavaScript:" class="btn_white" @click="goListBack">List</a>
            <div v-if="creationYn == 'Y'" class="btn_right">
                <a href="JavaScript:" class="btn_blue" @click="save">Save</a>
            </div>
        </div>
    </div>
</template>

<script>
import $                from 'jquery';
import qs               from 'query-string';
import Vue              from 'vue';
import api              from '@/service';
import axios            from 'axios';
import store            from '@/vuex/store';
import { EventBus }     from '@/utils/EventBus';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import UserAddPopup     from '~va/system/userRole/UserAddPopup';

export default {
    name: 'EurAdminSetDetail',
    props: {
        params: {},
//        pNationCd: { type: String, default: '' },
        pParams: { type: Object, default: {} },
    },
    components: {
//        'skp-breadcrumbs': SKPBreadcrumbs
    },
    computed: {
        ...mapGetters({
            sysParams: 'getParams',
            loginRhq: 'getLoginRhq',
            corpCd: 'getCorpCd',
            loginNo: 'getLoginNo',
        }),
    },
    data() {
        return {
            creationYn : '',
            rhqCdList: [],
            corpNoList: [],
            aprAutoTypes: [],
            aprRuleTypes: [],
            vocUsers: [],
            selectAll: false,
            rhqCd: '',
            rhqNm: '',
            corpNo: '',
            corpNm: '',
            countryCd: '',
            countryNm: '',
            aprAutoTpCd: '',
            aprRuleTpCd: '',
            aprFrstUser: '',
            aprScndUser: '',
            readEfctMax: '',
            readEfctDay: '',
            userExpireMax: '',
            userExpireMon: '',
            expireUseYn: '',
            adminAuthYn: ''
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            return await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
        },
        getVocUsers() {
            const params = {countryCd: this.countryCd};
            return axios
                .post(`${SDLUtil.API_URL}/basis/eur/getVocUsers.skp`, qs.stringify(params))
                .then(resp => {
                    this.vocUsers = resp.data.rows;
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        getParams() {
            let newList = [];
            this.vocUsers.forEach(elm => {
                newList.push(elm.LOGIN_NO);
            });
            let params = {
                  saveMode      : '1'
                , countryCd     : this.countryCd
                , aprAutoTpCd   : this.aprAutoTpCd
                , aprRuleTpCd   : this.aprRuleTpCd
                , userExpireMax : this.userExpireMax
                , userExpireMon : this.userExpireMon
                , readEfctMax   : this.readEfctMax
                , readEfctDay   : this.readEfctDay
                , expireUseYn   : this.expireUseYn
                , vocUsers      : newList
            };
            return params;
        },
        async execSave() {
            return axios
                .post(`${SDLUtil.API_URL}/basis/eur/saveSetValueByCountry.skp`, qs.stringify(this.getParams()))
                .then(resp => {
                    if (resp.data.result) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                    } else {
                        SDLUtil.errorAlert('Error occured.');
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        // 선택 Checkbox 클릭 시..
        selectRowChk(item) {
            // 개별 checkbix click
            if (!item.selected) {
                if (this.selectAll) {
                    this.selectAll = false;
                }
            }
        },
        // 전체선택 클릭 시..
        checkAll() {
            // 전체 checkbox click
            this.vocUsers.forEach(item => {
                item.selected = this.selectAll;
            });
        },
        // [Delete] 버튼 클릭 시..
        userDel() {
            let newList = [];
            this.vocUsers.forEach(elm => {
                if (!elm.selected) newList.push(elm);
            });

            if (newList.length == this.vocUsers.length) {
                SDLUtil.alert('No selected item to delete.');
            } else this.vocUsers = newList;
        },
        // [Add] 버튼 클릭 시...
        userAdd() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                UserAddPopup, {
                    title: 'Search User',
                    pAuthCorpId: '',
                    pAuthId: '',
                    pRhqCdList: this.rhqCdList,
                    pCorpNoList: this.corpNoList,
                    pMenuMode: true,
                    rtnUserFunc: (arg1) => {
                        arg1.forEach(elm => {
                            let user = {};
                            user.LOGIN_NO = elm.split('^')[0];
                            user.LOGIN_ID = elm.split('^')[1];
                            user.LOGIN_NM = elm.split('^')[2];
                            user.EMAIL    = elm.split('^')[3];
                            this.vocUsers.push(user);
                        });
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        save() {
            if (this.readEfctDay < 1) {
                SDLUtil.alert('Input the [Repair Info Effective Period] value more than 1.');
                return false;
            }
            if (this.userExpireMon < 1) {
                SDLUtil.alert('Input the [User Registration Effective Period] value more than 1.');
                return false;
            }
            if (Number(this.readEfctMax) < Number(this.readEfctDay)) {
                SDLUtil.alert('The [Repair Info Effective Period] value is too large.<br>Please enter ' + this.readEfctMax + ' or less.');
                return false;
            }
            if (Number(this.userExpireMax) < Number(this.userExpireMon)) {
                SDLUtil.alert('The [User Registration Effective Period] value is too large.<br>Please enter ' + this.userExpireMax + ' or less.');
                return false;
            }
            if (this.vocUsers.length == 0) {
                SDLUtil.alert('There must be at least 1 Charge of VOC.<br>Click the [Add] button to add it.');
                return false;
            }
            
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    this.execSave();
                },
            });

        },
        goListBack() {
            EventBus.$emit('goCountrySetList', 1);
        },
        onlyNumber(e) { 
            SDLUtil.onlyNumber(e); 
        },
    },
    mounted() {
        api.getCommonCodeList('APPR_AUTO_TYPE', 'A').then(resp => {
            this.aprAutoTypes = resp;
        });
        api.getCommonCodeList('APPR_RULE_TYPE', 'A').then(resp => {
            this.aprRuleTypes = resp;
        });

        this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
            this.rhqCdList = data;
            this.getCodeComboList(this.rhqCdList[0].code, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
            });
        });

        this.creationYn    = this.sysParams.creationYn;
        this.rhqCd          = this.pParams.RHQ_CD;
        this.rhqNm          = this.pParams.RHQ_NM;
        this.corpNo         = this.pParams.CORP_NO;
        this.corpNm         = this.pParams.CORP_NM;
        this.countryCd      = this.pParams.COUNTRY_CD;
        this.countryNm      = this.pParams.COUNTRY_NM;
        this.aprAutoTpCd    = this.pParams.APR_AUTO_TP_CD || '02';
        this.aprRuleTpCd    = this.pParams.APR_RULE_TP_CD || '01';
        this.userExpireMax  = this.pParams.USER_EXPIRE_MAX || '12';
        this.userExpireMon  = this.pParams.USER_EXPIRE_MON;
        this.expireUseYn    = this.pParams.EXPIRE_USE_YN;
        this.readEfctMax    = this.pParams.READ_EFCT_MAX || '7';
        this.readEfctDay    = this.pParams.READ_EFCT_DAY;
        this.adminAuthYn    = this.pParams.ADMIN_AUTH_YN;
        console.log('this.adminAuthYn ===> ', this.adminAuthYn);

        this.getVocUsers();
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/SettingByCountryDetail.vue